import { CommunityChannelApi } from '@ps/api/community-channel';
import { withClientAPI } from '@ps/functions/utils/api';

/**
 * Join a community channel — adds the current user as a member of
 * `stores/{creatorId}/communityChannels/{channelId}`. Membership is what unlocks
 * a private channel's message history (the server returns an empty feed until you
 * join), mirroring PopshopRN's `joinChannel`. The caller must already hold the
 * required subscription level for a private channel (the server enforces it too).
 */
export async function joinChannel({
  creatorId,
  channelId,
  userId,
}: {
  creatorId: string;
  channelId: string;
  userId: string;
}): Promise<void> {
  const api = withClientAPI(CommunityChannelApi);
  await api.communityChannelApiControllerAddMemberToCommunityChannel({
    sellerId: creatorId,
    channelId,
    AddMemberToCommunityChannelRequest: { userId },
  });
}
